import androidx.compose.runtime.Composable

@Composable
actual fun HandleExitOnBack() {
    //No-Op
}